import { PREFIX } from '../constants';
import asyncBuilder from 'utilities/actions';
import repository from 'client/repository';

export default {
    getTheme: asyncBuilder(PREFIX, () => {
        return repository.themes.getTheme();
    })
}